import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { history } from './_helpers/history';
import useWindowSizeStore from './_store/useWindowSizeStore';
import useUiStateStore from './_store/useUiStateStore';

function App() {
    history.navigate = useNavigate();
    history.location = useLocation();
    const { setSize, width, height, windowMode}  = useWindowSizeStore();
	const { isRegistPopupOpen, isCheckupCardPopupOpen, setCheckupCardPopupOpen } = useUiStateStore();

    useEffect(() => {
		const handleResize = () => {
			setSize(window.innerWidth, window.innerHeight);
		};

		window.addEventListener('resize', handleResize);
		handleResize(); // 초기 사이즈 설정
	
		return () => window.removeEventListener('resize', handleResize);
    }, [setSize]);

	useEffect(() => {
		// cardPopup open인데 화면 사이즈 커질 경우 popup close
		if(windowMode === 'pc' && isCheckupCardPopupOpen) {
			setCheckupCardPopupOpen(false);
		}
	}, [width, height, windowMode]);
	
	useEffect(() => {
		if(isRegistPopupOpen || isCheckupCardPopupOpen) {
			document.body.classList.add('no-scroll');
		} else {
			document.body.classList.remove('no-scroll');
		}
	}, [isRegistPopupOpen, isCheckupCardPopupOpen]);

    return (
		<>
			<AppRoutes />
		</>
    );
}

export default App;
